var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"risk-chart position-relative flex-grow-1 mt-3"},[(_vm.isLoading)?_c('div',{staticClass:"map-loading"},[_c('BSpinner',{staticClass:"map-spinner",attrs:{"variant":"primary"}})],1):_vm._e(),_c('div',{staticClass:"w-100 h-100",attrs:{"id":"event-detail-mini-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }